<template>
	<div id="top-nav">
		<div class="wrapper">
			<div class="left">
				<router-link to="/"><img :src="currentLogo" class="logo" @mouseenter="currentLogo = logoHover" @mouseleave="currentLogo = logo" /></router-link>
			</div><div class="right">
				<router-link to="/">Über uns</router-link>
				<router-link to="/location">Anfahrt</router-link>
				<router-link to="/contact" class="contact"><i class="far fa-envelope" style="margin-right: 10px;"></i>Kontakt</router-link>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TopNav',
	data() {
		return {
			logo: require("@/assets/logo-light.svg"),
			currentLogo: require("@/assets/logo-light.svg"),
			logoHover: require("@/assets/logo-light-hover.svg")
		}
	}
}
</script>

<style lang="scss" scoped>
$background-color: #28373B;
$base-color: #B10B16;
#top-nav {
	margin: 0;
	width: 100%;
	box-sizing: border-box;
	background: $background-color;
	border-bottom: 3px solid $base-color;
	color: #fff;
	vertical-align: bottom;

	.logo {
		margin: 15px 10px;
		max-width: 300px;
	}

	.left, .right {
		display: inline-block;
		box-sizing: border-box;
		margin:0;
		vertical-align: middle;
	}

	.left {
		width: 275px;
		text-align: left;
	}

	.right {
		width: calc(100% - 275px);
		text-align: right;

		a {
			display: inline-block;
			min-width: 100px;
			text-align: center;
			color: #fff;
			text-decoration: none;
			margin: 20px 10px;
			text-transform: uppercase;
			transition: .15s color, .15s background;

			&.router-link-exact-active {
				color: $base-color;
				font-weight: 700;
			}

			&:hover {
				color: $base-color;
			}

			&.contact {
				border: 1px solid #fff;
				background: transparent;
				color: #fff;
				padding: 10px 20px;

				&:hover, &.router-link-exact-active {
					background: #fff;
					color: $background-color;
				}
			}
		}
	}
}

@media (max-width: 500px) {
	#top-nav {
		.left, .right {
			display: block;
			text-align: center;
			width: 100%;
			padding: 10px;
		}
		.right {
			a {
				min-width: 50px;
				margin: 10px 10px;
			}
		}
		h1 img {
			max-width: 75%;
		}
	}
}
</style>
